import { LanguageOption } from '@/core/types';

const HOMEPORT_ONLY_LANGUAGE_CHOICES: LanguageOption[] = [
  { code: 'fa', label: 'فارسی' },
];

export const normalizeLanguageChoices = (
  languageChoices?: string[] | string,
): string[] => {
  const choices = Array.isArray(languageChoices)
    ? languageChoices
    : languageChoices?.split(',') || [];

  return choices.map((code) => code.trim()).filter(Boolean);
};

export const mergeLanguageChoices = (
  serverLanguages: [string, string][] = [],
): LanguageOption[] => {
  const serverLanguageCodes = new Set(serverLanguages.map(([code]) => code));

  return [
    ...HOMEPORT_ONLY_LANGUAGE_CHOICES.filter(
      ({ code }) => !serverLanguageCodes.has(code),
    ),
    ...serverLanguages.map(([code, label]) => ({ code, label })),
  ];
};
